export enum DropdownSize {
  Small = 'small',
  Middle = 'middle',
  Large = 'large',
}
